import { ContentType } from '@/models/ContentType';

export default class Content {
    id;
    section_id;
    sort_order;
    type;
    headline;
    
    constructor(type, id, section_id){
        this.id = id
        this.section_id = section_id;
        this.type = type;
        
        this.createContentFromContentType(type);
        this.headline = "";
    }

    createContentFromContentType(type){
        switch (type) {
            case ContentType.Checklist:
                this.items = [];
                break;
            case ContentType.FileList:
                this.files = [];
                break;
            default:
                break;
        }
    }
}


